import { Col, Row } from 'react-bootstrap';
import Button from 'components/base/Button';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
// import bg1 from 'assets/img/bg/bg-36.png';
// import bg2 from 'assets/img/bg/bg-34.png';
import bg2 from 'assets/img/bg/Screenshot_1.png';
import bg3 from 'assets/img/bg/bg-35.png';
import bg4 from 'assets/img/bg/bg-39.png';
import smarterNutrition from 'assets/img/bg/smarter_nutrition_mobile.png';
import { useAppContext } from 'providers/AppProvider';

const HeroHeader = () => {
  const { getThemeColor } = useAppContext();
  return (
    <section id="home" className="overflow-hidden pb-0 pt-0">
      <div className="hero-header-container-alternate position-relative">
        <div className="container-small px-lg-7 px-xxl-3">
          <Row className="align-items-center">
            <Col
              lg={6}
              className="pt-8 pb-6 position-relative z-5 text-center text-lg-start"
            >
              <h1 className="fs-3 fs-md-2 fs-xl-2 fw-black mb-4">
                <span
                  className="me-3"
                  style={{ color: getThemeColor('primary') }}
                >
                  Smarter Nutrition
                </span>
                <br />
                <span style={{ color: getThemeColor('primary') }}>
                  Logging{' '}
                </span>{' '}
                <span className="fs-4 fs-md-3 fs-xl-3">Smarter Healthcare</span>
              </h1>
              {/* <p className="mb-5 pe-xl-10">
                <b>AI-powered</b> food recognition meets clinical accuracy —
                designed for <b>dietitians</b>.
              </p> */}
              <Button
                as={Link}
                to="#contact"
                variant="primary"
                size="lg"
                className="rounded-pill me-3"
                onClick={e => {
                  e.preventDefault();
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Request a Demo
              </Button>
              {/* <Button
                as={Link}
                to="#how-it-works"
                variant="link"
                endIcon={
                  <FontAwesomeIcon icon={faAngleRight} className="ms-2 fs-9" />
                }
                className="me-2 fs-8 p-0"
                onClick={e => {
                  e.preventDefault();
                  const howItWorksSection =
                    document.getElementById('how-it-works');
                  if (howItWorksSection) {
                    howItWorksSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Learn More
              </Button> */}
            </Col>
            <Col lg="auto" className="d-none d-lg-block">
              <div className="hero-image-container position-absolute h-100 end-0 d-flex">
                <div className="position-relative">
                  {/* <div className="position-absolute end-0 hero-image-container-overlay" /> */}

                  {/* <img
                                        src={bg1}
                                        alt=""
                                        className="position-absolute end-0 hero-image-container-bg"
                                    />

                                    <img
                                        src={bg2}
                                        alt=""
                                        className="w-100 d-dark-none rounded-2 hero-image-shadow"
                                    />

                                    <img
                                        src={bg3}
                                        alt=""
                                        className="w-100 d-light-none rounded-2 hero-image-shadow"
                                    /> */}

                  {/* <img
                    src={bg1}
                    alt=""
                    className="position-absolute end-0 hero-image-container-bg"
                  /> */}

                  <img
                    src={smarterNutrition}
                    alt=""
                    className="w-100 h-75 d-dark-none rounded-2"
                  />

                  <img
                    src={bg3}
                    alt=""
                    className="w-100 d-light-none rounded-2 hero-image-shadow"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="container-small px-md-8 mb-8 d-lg-none">
          <div className="position-relative">
            {/* <div className="position-absolute end-0 hero-image-container-overlay" />

                        <img
                            src={bg4}
                            alt=""
                            className="position-absolute top-50 hero-image-container-bg"
                        />
                        <img
                            src={bg2}
                            alt=""
                            className="img-fluid ms-auto d-dark-none rounded-2 hero-image-shadow"
                        />
                        <img
                            src={bg3}
                            alt=""
                            className="img-fluid ms-auto d-light-none rounded-2 hero-image-shadow"
                        /> */}

            <div className="position-absolute end-0" />

            <img
              src={smarterNutrition}
              alt=""
              className="img-fluid ms-auto d-dark-none rounded-2"
              style={{ backgroundColor: 'transparent' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHeader;
